<template>
	<a @click="close()" v-if="nav.type === 'external-menu-item'" :href="nav.href" target="_blank" class="menu-item">{{ nav.name }}<sup class="ml-1"><font-awesome-icon class="text-xs" icon="fa-solid fa-arrow-up-right-from-square" /></sup></a>
	<li @click="click(nav)" v-else-if="nav.clickable" class="menu-item">
		<RouterLink @click="close()" :to="nav.href ?? '/'">{{ nav.name }}</RouterLink>
    <FontAwesomeIcon v-if="nav.type === 'dropdown-menu-item' || nav.type === 'recursive-dropdown-menu'" icon="fa-solid fa-chevron-down" class="ml-auto" />
	</li>
	<li @click="click(nav)" v-else class="menu-item">
		{{ nav.name }}
    <FontAwesomeIcon v-if="nav.type === 'dropdown-menu-item' || nav.type === 'recursive-dropdown-menu'" icon="fa-solid fa-chevron-down" class="ml-auto" />
	</li>
</template>

<script setup>
defineProps({
  nav: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['click', 'close'])

function click(nav) {
  emit('click', nav)
}

function close() {
  emit('close')
}
</script>

<style scoped>
.menu-item {
  @apply flex items-center px-3 py-2 -mx-3 text-base font-semibold leading-7 text-gray-900 rounded-lg cursor-pointer hover:bg-gray-50;
}
</style>
